module.exports = __webpack_public_path__ + "src/images/uikit-logo.dfdf43f3044bd4c4c57532c757d1cf8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/uikit-logo.svg
// module id = 109
// module chunks = 0